module.exports = __webpack_public_path__ + "assets/docx/jld.ccf5c5c7bbd6cedbfab9a9b576c2a98a.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/jld.docx
// module id = QUcX
// module chunks = 208